const developmentEnv = {
  API_URL: "http://localhost:8090",
  TOKEN_APCD: "Bearer $2y$10$elalv5TR.Cot18s6I5w0seZKT/ModUriGVMwwhvOlfZG3yu94DSze",
  PROJECT_URL: "https://cadastro.spdataminhaclinica-staging.com.br",
  REDIRECT_URL: "https://web.spdataminhaclinica-staging.com.br",
  CNPJAR_SW: "01579286000174",
  IDPRODUTO_SW: "28556"

};

const builtEnv = {
  API_URL: "https://api.spdataminhaclinica.com.br",
  TOKEN_APCD: "Bearer $2y$10$elalv5TR.Cot18s6I5w0seZKT/ModUriGVMwwhvOlfZG3yu94DSze",
  PROJECT_URL: "https://cadastro.spdataminhaclinica.com.br",
  REDIRECT_URL: "https://web.spdataminhaclinica.com.br",
  CNPJAR_SW: "01579286000174",
  IDPRODUTO_SW: "28556"
};

export const env =
  process.env.NODE_ENV === "development" ? developmentEnv : builtEnv;
